import Axios from 'axios';
import { sendRequest } from './general';


export const getMidPointPrices = async (params) => await sendRequest(Axios.get('/api/point/midpoints', { params }));